import { useEffect, useState } from "react";
import ContractReturnGrid from "./Grid";
import { constants, messages } from "../../common/constants";
import swal from "sweetalert";
import { updateContractMaintenance } from "../../utils/API";
import _ from "lodash";

interface ContractReturnProps {
  selectedRows: any;
  updateGridCells?: any;
  setDoShowFullScreenLoader?: any;
  doShowFullScreenLoader?: any;
  handleContractReturnClose?: any;
  user: any;
  type?: string;
}

const ContractReturn = ({
  selectedRows,
  updateGridCells,
  setDoShowFullScreenLoader,
  doShowFullScreenLoader,
  handleContractReturnClose,
  user,
  type,
}: ContractReturnProps) => {
  const heightAG_1 = 30;
  const [contracts, setContracts] = useState<any>(selectedRows);
  const [gridApi, setGridApi] = useState<any>(null);
  const [columnApi, setColumnApi] = useState<any>(null);
  const [isValidRequest, setIsValidRequest] = useState<boolean>(false);
  const [fullReturnedContracts, setFullReturnedContracts] = useState<any>([])
  const [isResetFullReturn, setResetFullReturn] = useState<boolean>(false);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const [isContractsSubmitted, setIsContractsSubmitted]  = useState<boolean>(false);

  const onUpdateCell = (data: any, value: any) => {
    value =
      _.isString(data?.newValue) && data?.newValue?.includes(",")
        ? parseInt(data?.newValue?.replace(/,/g, ""))
        : data?.newValue;
    data.newValue = isNaN(value) ? 0 : parseInt(value);
    try {
      if (
        data.newValue &&
        !isNaN(data.newValue) &&
        parseFloat(data.newValue) > 0
      ) {
        data.hasError = false;
        data.newValue =
          _.isString(data?.newValue) && data?.newValue?.includes(",")
            ? parseInt(data?.newValue?.replace(/,/g, ""))
            : data?.newValue;
        let contractValue = data?.newValue * data?.contractPrice;
        data.remaining_quantity = parseFloat(data?.quantity)  - parseFloat(data?.newValue)
        data.newContractValue = data?.newValue * data?.contractPrice;
        if (contractValue > 999999999999.99 || data.remaining_quantity < 0) {
          data.hasError = true;
        }
      } else {
        data.hasError = true;
        data.newContractValue = null;
        data.remaining_quantity = null;
        data.newValue = 0;
      }
    } catch (error) {
    } finally {
      setContracts((previousRows: any) => {
        let index = previousRows?.findIndex(
          (x: any) =>
            x?.id === data?.id && x.contract_type === data?.contract_type
        );
        if (index >= 0) {
          data.isFullReturnedEdited = data?.isFullyReturned && data?.remaining_quantity>0
          previousRows[index] = data;
        }

        let errorIndex = previousRows?.findIndex(
          (x: any) => x.hasError === true
        );
        setIsValidRequest(errorIndex === -1);

        return previousRows;
      });
    }
  };

  const updateContract = async () => {
    try {
      setDoShowFullScreenLoader(true);
      setIsContractsSubmitted(true)
      const updatedRows = contracts?.filter(
        (x: any) => x?.newValue && !_.isNaN(x?.newValue) && x?.newValue > 0
      );
      if (updatedRows && updatedRows?.length > 0) {
        let rows: any[] = [];
        let errors: any[] = [];
        rows = updatedRows.map((r: any) => ({
          contractId: r?.contract_id,
          action: "RETURN",
          bl: "B",
          changes: [
            {
              attribute: "QUANTITY_RETURN",
              value:
                r?.newValue && !_.isNaN(r?.newValue)
                  ? r?.newValue?.toString()
                  : "0",
            },
            {
              attribute: "CONTRA_PARTY",
              value: r?.cpty_id && !_.isEmpty(r?.cpty_id) ? r?.cpty_id : "",
            },
            {
              attribute: "COMMENTS",
              value: r?.comments && !_.isEmpty(r?.comments) ? r?.comments : "",
            },
            {
              attribute: "DELIVERY_CODE",
              value: "D",
            },
            {
              attribute: "CONTRACT_PRICE",
              value:
                r?.contractPrice && !_.isEmpty(r?.contractPrice)
                  ? r?.contractPrice
                  : 0,
            },
          ],
        }));
        if (rows && rows?.length >= 0) {
          updateGridCells(updatedRows)
          const accessToken = window.localStorage.getItem("refreshtoken");
          const response = await updateContractMaintenance(
            rows,
            user?.tokenType,
            accessToken
          );
          if (response?.status === 200) {
            let cmUpdateResponse = await response?.json();
            cmUpdateResponse?.forEach((obj: any) => {
              if (obj.hasError === true) {
                errors.push(obj.status + " " + obj.error);
              }
            });
            if (errors.length > 0) {
              errors = _.uniq(errors);
              let error = messages.statuserror + "\n\n Error(s): \n";
              errors.map((e: any) => {
                error = error + e + "\n";
              });
              swal({
                title: constants.Error,
                text: error,
                dangerMode: true,
                closeOnClickOutside: false,
              }).then(()=>{
                setDoShowFullScreenLoader(false);
                handleContractReturnClose();
              });
              
            } 
          }
        }
      }
    } catch (err) {
      setDoShowFullScreenLoader(false);
    } finally {
      setDoShowFullScreenLoader(false);
      handleContractReturnClose();
      setIsContractsSubmitted(false)
    }
  };

  useEffect(()=>{
    if(fullReturnedContracts?.length>0){
      setIsInitialLoad(false)
    }
    if(fullReturnedContracts && (!isInitialLoad || fullReturnedContracts?.length>0)){
    
    const rows =  _.map([...contracts], (value:any)=>{
        if(_.some(fullReturnedContracts, ['contract_id', value?.contract_id])){
          value.isFullyReturned = true
          value.newValue = parseFloat(value?.quantity)
          value.remaining_quantity = 0
          value.hasError = false
        }else{
          
          const quantity = parseFloat(value?.quantity)
          value.newValue = (quantity !==  value.newValue)? value?.newValue: null
          value.remaining_quantity = quantity !==  value.newValue ? value?.remaining_quantity: null
          value.hasError = value.remaining_quantity<0
          value.isFullyReturned = false
        }

        return value
      })

      let errorIndex = rows?.findIndex(
        (x: any) => x.hasError === true
      );
      const updatedRows = rows?.filter(
        (x: any) => x?.newValue && !_.isNaN(x?.newValue) && x?.newValue > 0
      );
      setIsValidRequest(errorIndex === -1 && updatedRows?.length>0);
      setContracts([...rows])
    }
  },[fullReturnedContracts])

useEffect(()=>{
  if(isResetFullReturn){
      const rows =  _.map([...selectedRows], (value:any)=>{
       return {...value, 
        isFullyReturned : false,
        newValue : null,
        remaining_quantity : null}
      })
      setIsValidRequest(false);
      setContracts([...rows])
  }
},[isResetFullReturn])

  return (
    <>
      <ContractReturnGrid
        rowData={contracts}
        height={heightAG_1}
        onCellChange={(data: any, value: any) => {
          onUpdateCell(data, value);
        }}
        getGridApi={(gridApi: any) => {
          setGridApi(gridApi);
        }}
        getColumnApi={(columnApi: any) => {
          setColumnApi(columnApi);
        }}
        type={type}
        setSelectedRows={(rows:any)=>setFullReturnedContracts(rows)}
        setResetFullReturn={(isReset:boolean)=>setResetFullReturn(isReset)}
      />
      <div className="d-flex justify-content-end mt-3 ">
        <div className="ms-2 h-100 d-flex align-items-center metrics-div">
          <button
            id="submit"
            className={"btn btn-primary uploadSheet-submit-Btn"}
            onClick={() => {
              updateContract();
            }}
            disabled={!isValidRequest || isContractsSubmitted}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default ContractReturn;
